/* eslint-disable */
// 入退場管理用メッセージ
export const enterSettings = {
  I: {
    '004-01': '登録中です',
    '004-02':
      'CCUSへの現場登録には時間がかかります。登録が完了したら通知でお知らせします。',
    '004-03': '連携中です',
    '004-04':
      'CCUSへの施工体制の連携には時間がかかります。 \n連携が完了したら通知でお知らせします。',
    '004-05': 'CCUS現場情報を取得できませんでした',
    '005-01': '登録できる作業員がいません',
    '005-02': '登録済み作業員がいません',
    '005-03': '{0}{1}の作業員登録が完了しました。',
    '005-04': '続けて労務安全情報の登録を行いますか？',
    '005-05':
      '本連携をもって、CCUSシステムとBuildee間で該当の作業員の技能者情報を取得することに同意いただきます。',
    '005-07': 'CCUS通信中',
    '005-08': 'お待ちください',
    '005-09': '情報を修正しますか？',
    '005-10': 'このまま作業員の情報を登録して、あとで修正することもできます。',
    '005-11': 'CCUSとの連携ができませんでした。',
    '005-12': '情報を修正する',
    '005-13': 'このまま登録する',
    '005-14': 'このまま更新する',
    '006-01': '入退場実績承認',
    '006-02': '以下の入退場実績を承認します。',
    '006-03': '入退場実績承認解除',
    '006-04': '以下の入退場実績の承認を解除します。',
    '006-05': '入退場実績削除',
    '006-06': '以下の入退場実績を削除します。',
    '006-07': 'CCUSに送付されたデータは、CCUS上からは削除されません。',
    '006-08': '入退場実績全承認',
    '006-09': '全ての未承認入退場実績を承認します。',
    '006-10': '入退場実績追加',
    '006-11': '入退場実績更新',
    '006-12': '協力会社選択',
    '006-13': '協力会社を選択してください',
    '006-14': '作業員一覧',
    '006-15': '施工体系選択',
    '006-16': '施工体系を選択してください',
    '006-17': '作業員を検索してください',
    '007-01':
      '下記の作業員をgatekeeper確認用現場の作業員として割り当て、入退場データを登録します。',
    '007-02': '割り当てた作業員に入退場実績を追加しました。',
    '008-01': '施工体制に登録されていない方の入場があります。',
    '008-02': '承認が必要な入退場実績があります。',
    '008-03': 'エラー内容',
    '009-01':
      'チェックを付けて現場を登録すると、CCUSにも新規登録することができます。\n操作を続行する場合は「OK」を押してください。\n\nすでにCCUSに登録済みの場合は「キャンセル」を押してください。',
    '009-02': '※CCUSの現場情報はBuildeeからは更新できません',
    '010-01': '入退場機器利用期間の変更をお勧めします',
    '011-01':
      '顔画像の送信を開始しました。\n送信件数や通信状況によって時間がかかる場合があります。\n\n1時間経過しても顔写真送信ステータスが「未送信」の場合、入退場機器の電源を切り入りし、送信を再度お試しください。\n\n上記でも解決しない場合、以下までお問い合わせください。\n・BANKEN FACEご利用の場合：BANKENサポート\n・顔レコご利用の場合：Buildeeカスタマーサポート',
    '012-02': '未送信の顔写真情報があります。\n機器に送信しますか？',
    '013-01': 'スポンサーJVがCCUSを退会しているため、就業履歴の送信を停止しています。',
    '013-02': 'スポンサーJVがCCUSを退会しているため、CCUS連携を停止しています。',
    '013-03':
      'この協力会社はCCUSを退会しています。退会した協力会社の就業履歴はCCUSに送信されません。\nCCUSに再加入した場合、協力会社にて会社情報のCCUS連携情報を再加入情報に更新することで就業履歴の送信が再開されます。',
    '013-04':
      'この協力会社はCCUSを退会しています。退会した協力会社はCCUS連携が行えません。\nCCUSに再加入した場合、協力会社にて会社情報のCCUS連携情報を再加入情報に更新することで再度CCUS連携を行えます。',
    '013-05': '元請がCCUSを退会しているため、就業履歴の送信を停止しています。',
    '013-06': '元請がCCUSを退会しているため、CCUS連携を停止しています。',
    '013-07':
      'CCUSの就業履歴蓄積期間外の入退場実績の送信が行われエラーが発生しています。\nCCUSの管理画面にて現場情報項目の「就業履歴蓄積期間」をご確認ください。',
    '014-01': '反映開始日は翌日以降の未来日が設定可能です。',
    '015-01': '設定済み',
    '016-01': '※スポンサー会社のみが設定できます。',
    '017-01': '※本機能は本社管理者・支店管理者のみが設定できます。',
    '076-01':
      'CCUSから技能者情報を取得しました。\nBuildeeのデータに反映するには、各項目の編集画面から転記を行ってください。',
  },
  W: {
    '001-001': '未承認の入退場実績を選択してください。',
    '001-002': '削除対象の入退場実績を選択してください。',
    '001-003': '退場時刻は入場時刻より前に設定できません。',
    '001-004': '承認済の入退場実績を選択してください。',
    '001-005': '未承認の入退場実績が1件もありません。',
    '001-007':
      '入退場実績の「作業実績反映機能」をOFFにして再度ONにする場合は、翌日以降が開始日となります。\nご注意ください。',
    '005-01': '以下の作業員を削除します。',
    '005-02': '現場の施工体制への割り当ても自動的に削除されます。',
    '005-03': '削除対象の作業員を\n選択してください。',
  },
  E: {
    '001-006': '現場が選択されていません。',
    '005-01': '作業員の登録に失敗しました',
    '005-02': '作業員の登録解除に失敗しました',
    '007-01': '{0}件の不明な入退場データがありませんでした',
    '007-02': 'CSV出力ができません',
    '007-03':
      '出力対象が上限（3000件）を超えているためCSV出力ができません。\n検索結果が3000件以下となるように期間を絞り込み、\n再度「表示データをCSV出力」ボタンを押してください。',
    '007-04':
      '上限を超えているためCSV出力することができません。\n検索結果が1000件に収まるよう、検索条件を変更してください。',
    '001-01': '実績反映できません',
    '001-02':
      '{0}件中 {1}件の不明な入退場データの反映に失敗しました。\n\n入退場実績がすでに登録されています。\n実績反映によりCCUS送信済みデータの入場日に変更が生じるため、反映することができません。\n以下のデータを入退場実績に反映したい場合には、入退場実績画面で原因の入退場実績を削除してください。',
    '001-03':
      '※Buildeeの日またぎ時刻の設定によっては、不明な入退場データと原因の入退場実績の入場日に1日分の差異が生じることがあります。',
    '001-04': '翌日以降の日付を設定してください。',
    '001-05':
      '別ユーザーによりすでに入退場実績の作業実績反映機能が有効化されています。\n画面再読み込み後、設定内容についてご確認ください。',
    '001-06':
      '入退場実績の作業実績反映機能は本社管理者・支店管理者のみが設定できます。',
  },
};



// WEBPACK FOOTER //
// ./src/utilities/messages/enterSettings.js